// extracted by mini-css-extract-plugin
export default {"overlay":"FullPageLoader_overlay__wY+0r","spinner":"FullPageLoader_spinner__3WzPs"};